const roleAll = '*';
const roleAdmin = 'role:Admin';
const roleManagement = 'role:Management';

// let albumClp = {
//     get: { '*': true, 'role:admin': true },
//     find: { '*': true, 'role:admin': true },
//     create: { 'role:admin': true },
//     update: { 'role:admin': true },
//     delete: { 'role:admin': true },
//     addField: {}
// };

let albumClp = ()=>{
    let clp = {};
    createClp(clp, 'get',roleAll);
    createClp(clp, 'find',roleAll);
    createClp(clp, 'count',roleAll);
    createClp(clp, 'create',roleManagement, roleAdmin);
    createClp(clp, 'update',roleManagement, roleAdmin);
    createClp(clp, 'delete',roleManagement, roleAdmin);
    return createClp(clp, 'addField',roleAdmin);
};

let artistClp = ()=>{
    let clp = {};
    createClp(clp, 'get',roleAll);
    createClp(clp, 'find',roleAll);
    createClp(clp, 'count',roleAll);
    createClp(clp, 'create',roleManagement, roleAdmin);
    createClp(clp, 'update',roleManagement, roleAdmin);
    createClp(clp, 'delete',roleManagement, roleAdmin);
    return createClp(clp, 'addField',roleAdmin);
};

let fileClp = ()=>{
    let clp = {};
    createClp(clp, 'get',roleAll);
    createClp(clp, 'find',roleAll);
    createClp(clp, 'count',roleAll);
    createClp(clp, 'create',roleManagement, roleAdmin);
    createClp(clp, 'update',roleManagement, roleAdmin);
    createClp(clp, 'delete',roleManagement, roleAdmin);
    return createClp(clp, 'addField',roleAdmin);
};

let thumbnailClp = ()=>{
    let clp = {};
    createClp(clp, 'get',roleAll);
    createClp(clp, 'find',roleAll);
    createClp(clp, 'count',roleAll);
    createClp(clp, 'create',roleManagement, roleAdmin);
    createClp(clp, 'update',roleManagement, roleAdmin);
    createClp(clp, 'delete',roleManagement, roleAdmin);
    return createClp(clp, 'addField',roleAdmin);
};

let cdLinkClp = ()=>{
    let clp = {};
    createClp(clp, 'get',roleAll);
    createClp(clp, 'find',roleAll);
    createClp(clp, 'count',roleAll);
    createClp(clp, 'create',roleManagement, roleAdmin);
    createClp(clp, 'update',roleManagement, roleAdmin);
    createClp(clp, 'delete',roleManagement, roleAdmin);
    return createClp(clp, 'addField',roleAdmin);
};
let songTypeClp = ()=>{
    let clp = {};
    createClp(clp, 'get',roleAll);
    createClp(clp, 'find',roleAll);
    createClp(clp, 'count',roleAll);
    createClp(clp, 'create',roleManagement, roleAdmin);
    createClp(clp, 'update',roleManagement, roleAdmin);
    createClp(clp, 'delete',roleManagement, roleAdmin);
    return createClp(clp, 'addField',roleAdmin);
};

let cdLinkCategoryClp = ()=>{
    let clp = {};
    createClp(clp, 'get',roleAll);
    createClp(clp, 'find',roleAll);
    createClp(clp, 'count',roleAll);
    createClp(clp, 'create',roleManagement, roleAdmin);
    createClp(clp, 'update',roleManagement, roleAdmin);
    createClp(clp, 'delete',roleManagement, roleAdmin);
    return createClp(clp, 'addField',roleAdmin);
};

let mediaClp = ()=>{
    let clp = {};
    createClp(clp, 'get',roleAll);
    createClp(clp, 'find',roleAll);
    createClp(clp, 'count',roleAll);
    createClp(clp, 'create',roleManagement, roleAdmin);
    createClp(clp, 'update',roleManagement, roleAdmin);
    createClp(clp, 'delete',roleManagement, roleAdmin);
    return createClp(clp, 'addField',roleAdmin);
};


let songClp = ()=>{
    let clp = {};
    createClp(clp, 'get',roleAll);
    createClp(clp, 'find',roleAll);
    createClp(clp, 'count',roleAll);
    createClp(clp, 'create',roleManagement, roleAdmin);
    createClp(clp, 'update',roleManagement, roleAdmin);
    createClp(clp, 'delete',roleManagement, roleAdmin);
    return createClp(clp, 'addField',roleAdmin);
};

function createClp(clp, crud, ...params){
    let permissions = {};
    params.forEach(x=>{
        permissions[x] = true
    });
    clp[crud] = permissions;
    return clp;
}
export const ClpConstant = {
    albumClp,
    artistClp,
    mediaClp,
    thumbnailClp,
    songTypeClp,
    cdLinkClp,
    cdLinkCategoryClp,
    fileClp,
    songClp
};